module.exports = __webpack_public_path__ + "static/media/icon-back.237f3810.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-back.png
// module id = 198
// module chunks = 0